import WorkReportsHeader from 'component/WorkReports/WorkReportsHeader'
import WorkReportsTable from 'component/WorkReports/WorkReportsTable'
import React, { useState } from 'react'
import { WorkReportReviewStatus } from 'api/workReports/getWorkReports'

export type WorkReportsFiltersState = {
	clientId?: string
	contactId?: string
	q?: string
	statuses?: WorkReportReviewStatus | 'ALL'
	fromDayKey?: string
	toDayKey?: string
	reviewedOnly?: boolean
}

const WorkReportsPageLayout: React.FC = () => {
	const [filters, setFilters] = useState<WorkReportsFiltersState>({
		statuses: 'ALL',
	})

	return (
		<>
			<WorkReportsHeader filters={filters} onChange={setFilters} />
			<WorkReportsTable filters={filters} />
		</>
	)
}

export default WorkReportsPageLayout
